const Footer = () => {
	const block = document.querySelector(".footer");
	if (!block) {
		return;
	}
	const logo = block.querySelector(".footer__logo");
	const logoImage = block.querySelector(".footer__logo-i");

	const setLogoOffset = () => {
		logoImage.style.marginBottom = `-${logo.offsetHeight * 0.35}px`;
	};
	setLogoOffset();

	window.addEventListener("resize", (e) => {
		logoImage.style.marginBottom = 0;
		setLogoOffset();
	});
};

export default Footer;
